import { Fragment, FunctionComponent, useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import CallRestartedModal from '@/modules/RealtimeAttendance/components/CallRestartedModal'
import CallStartedModal from '@/modules/RealtimeAttendance/components/CallStartedModal'
import AttendanceStartedModal from '@/modules/RealtimeAttendance/components/AttendanceStartedModal'
import ScheduledCallStartedModal from '@/modules/RealtimeAttendance/components/ScheduledCallStartedModal'
import AttendanceLate from '@/modules/RealtimeAttendance/components/AttendanceLate'
import RescheduledByMedicModal from '@/modules/RealtimeAttendance/components/RescheduledByMedicModal'
import TokenValidationModal from '@/modules/RealtimeAttendance/components/TokenValidationModal'
import { useCallMonitoringStore } from '@/modules/VideoCall/store/call-monitoring-store'
import { validateRulesToAccessMeetStore } from '@/components/HOCs/ValidateRulesToAccessMeet/store'

const RealtimeAttendance: FunctionComponent = () => {
  const history = useHistory()

  const currentCallAppointmentId = useCallMonitoringStore(
    state => state.appointmentId,
  )
  const setIsAbleToAccessMeet = validateRulesToAccessMeetStore(
    store => store.setIsAbleToAccessMeet,
  )

  const currentVideoCallRoute = useMemo(() => {
    if (!currentCallAppointmentId) return '/chamada'

    return `/chamada?a=${currentCallAppointmentId}`
  }, [currentCallAppointmentId])

  return (
    <Fragment>
      <CallRestartedModal
        hookSuccess={() => history.push(currentVideoCallRoute)}
      />
      <CallStartedModal
        hookSuccess={() => history.push(currentVideoCallRoute)}
      />
      <ScheduledCallStartedModal
        hookSuccess={() => history.push(currentVideoCallRoute)}
      />
      <AttendanceStartedModal />
      <AttendanceLate />
      <RescheduledByMedicModal />
      <TokenValidationModal
        onActionClick={cb => {
          setIsAbleToAccessMeet(true)
          history.push('/chamada')
          cb()
        }}
      />
    </Fragment>
  )
}

export default RealtimeAttendance
